import { delay } from '@shared/utils/async';
import { HttpEndpoint } from '@/api/httpEndpoints';
import { MembersEndpoint as MembersEndpointModel, SemboUser } from './members.interfaces';
import { fakeMember } from './members.fake';
import { getStoredFakeData } from '@/components/shared/DevPanel/DevPanel.helpers';

const stored = getStoredFakeData();

export class MembersEndpoint extends HttpEndpoint implements MembersEndpointModel {
    public constructor(applicationUrl: string) {
        super(applicationUrl);
    }
    public GetMember(): Promise<SemboUser | null> {
        return this.get(`mvc/Members/GetMember`);
    }
    public OptInMember(username: string): Promise<void> {
        return this.post('mvc/Members/OptInMember', { username });
    }
}

export class FakeMembersEndpoint extends HttpEndpoint implements MembersEndpointModel {
    private realEndpoint: MembersEndpoint;

    public constructor(applicationUrl: string) {
        super(applicationUrl);
        this.realEndpoint = new MembersEndpoint(applicationUrl);
    }

    public async GetMember(): Promise<SemboUser | null> {
        if (stored.auth.enabled) {
            await delay(1000);
            return fakeMember;
        }

        // Reuse the real endpoint's logic
        return this.realEndpoint.GetMember();
    }

    public async OptInMember(username: string): Promise<void> {
        if (stored.auth.enabled) {
            return;
        }

        // Reuse the real endpoint's logic
        return this.realEndpoint.OptInMember(username);
    }
}
